import template from "./places_autocomplete.html";
import { setOptions, importLibrary } from "@googlemaps/js-api-loader";

class PlacesAutocompleteController {
    /* @ngInject */
    constructor($document, $q, $element) {
        this.$document = $document;
        this.$q = $q;
        this.$element = $element;
    }

    $onInit() {
        let ctrl = this;

        setOptions({
            key: process.env.GOOGLE_PUBLIC_API_KEY,
            v: "weekly",
            libraries: ["places"],
        });

        importLibrary("places").then(function (places) {
            let pacInputElement = ctrl.$element.find("div")[0];
            if (pacInputElement.childElementCount > 0) {
                return;
            }
            const options = {
                strictBounds: false,
                types: ctrl.lookups,
            };
            const placeAutocomplete = new places.PlaceAutocompleteElement();
            pacInputElement.appendChild(placeAutocomplete);
            placeAutocomplete.addEventListener(
                "gmp-select",
                function ({ placePrediction }) {
                    const place = placePrediction.toPlace();
                    ctrl.$q
                        .when(
                            place.fetchFields({
                                fields: [
                                    "displayName",
                                    "formattedAddress",
                                    "location",
                                    "addressComponents",
                                ],
                            }),
                        )
                        .then(function (placeData) {
                            ctrl.onPlaceUpdate({ place: placeData.place });
                            if (ctrl.lookups === ["address"]) {
                                ctrl.readableLocation =
                                    placeData.place.formattedAddress;
                            } else if (ctrl.lookups === ["establishment"]) {
                                ctrl.readableLocation =
                                    placeData.place.displayName;
                            }
                        });
                },
            );
        });
    }
}
export default {
    bindings: {
        onPlaceUpdate: "&",
        lookups: "<",
        placeholder: "@",
        readableLocation: "@",
    },
    controller: PlacesAutocompleteController,
    template: template,
    name: "placesAutocomplete",
};
